export const PopupType = Object.freeze({
	userProfile: 'im-user-settings-popup',
	userStatus: 'im-user-status-popup',
	recentContextMenu: 'im-recent-context-menu',
	recentHeaderMenu: 'im-recent-header-menu',
	createChatMenu: 'im-create-chat-menu',
	dialogMessageMenu: 'bx-im-message-context-menu',
	dialogAvatarMenu: 'bx-im-avatar-context-menu',
	dialogReactionUsers: 'bx-im-message-reaction-users',
	dialogReadUsers: 'bx-im-dialog-read-users'
});